<div class="col px-5">
  <div class="cbb-map-form__layout">
    <div class="cbb-map-form__card">
      <google-map
          [height]="'420px'"
          [width]="'100%'"
          [center]="center"
          [zoom]="zoom"
          [options]="mapOptions"
        >
          <map-marker
            [position]="{ lat: lat, lng: lng }"
            [options]="{ draggable: false }"
          >
          </map-marker>

          <map-marker
            *ngIf="blueMarkerVisible"
            [position]="{
              lat: complementaryAddressData.lat,
              lng: complementaryAddressData.lng
            }"
            [options]="{
              draggable: true,
              icon: 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png'
            }"
            (mapDragend)="onComplementaryMarkerDragEnd($event)"
          >
          </map-marker>
        </google-map>
    </div>

    <div class="cbb-map-form__card" [formGroup]="form">
        <h2 class="cbb-map-form__title">Ingrese la ubicación de despacho</h2>

        <div class="d-flex gap-2 cbb-map-form__field">
          <div class="cbb-map-form__col cbb-map-form__select-wrapper">
            <select class="cbb-map-form__control" formControlName="region">
              <option value="" selected disabled>Región</option>
              <option
                value="{{ item.nombreRegion }}"
                *ngFor="let item of regionesComunas"
              >
                {{ item.nombreRegion }}
              </option>
            </select>
          </div>
          <div class="cbb-map-form__col cbb-map-form__select-wrapper">
            <select class="cbb-map-form__control" formControlName="comuna">
              <option value="" selected disabled>Comuna</option>
              <option value="{{ item }}" *ngFor="let item of comunaByRegion">
                {{ item }}
              </option>
            </select>
          </div>
        </div>

        <div class="d-flex gap-2 cbb-map-form__field">
          <div class="cbb-map-form__col">
            <input
              class="cbb-map-form__control"
              type="text"
              placeholder="Calle"
              formControlName="street"
            />
          </div>
          <div class="cbb-map-form__col">
            <input
              class="cbb-map-form__control"
              type="text"
              placeholder="Número"
              formControlName="number"
            />
          </div>
        </div>

        <p class="text-danger mb-1" *ngIf="form.hasError('noValid')">
          Dirección no disponible
        </p>
        <p class="text-danger mb-1" *ngIf="form.hasError('queryLimit')">
          Demasiados intentos de obtener la dirección, intente más tarde.
        </p>

        <button
          *ngIf="!enabledSave"
          class="cbb-map-form__btn-verify"
          [disabled]="verificaTodosCampos"
          (click)="verificar()"
        >
          Verificar Dirección
        </button>

        <div *ngIf="blueMarkerVisible" class="mt-4">
          <h2 class="cbb-map-form__title mb-0">Punto de Acceso</h2>
          <p *ngIf="optional" class="mb-0 text-muted">(Opcional)</p>
          <p *ngIf="!optional" class="mb-0 mt-1 text-danger fw-bold">
            (Dirección no encontrada, por favor, mueva el pin a la dirección que desea la descarga o despacho de su pedido)
          </p>
          <p class="mt-2">Arrastre el pin azul en el mapa para indicar el punto de acceso a la obra:</p>

          <div class="cbb-map-form__field">
            <input
              class="cbb-map-form__control disable"
              id="complementaryAddress"
              placeholder="Dirección"
              type="text"
              [value]="complementaryAddress"
              readonly
            />
          </div>
          <div class="d-flex gap-2 cbb-map-form__field">
            <div class="cbb-map-form__col">
              <input
                class="cbb-map-form__control disable"
                id="complementaryStreet"
                placeholder="Calle"
                type="text"
                [value]="complementaryAddressData.street"
                readonly
              />
            </div>
            <div class="cbb-map-form__col">
              <input
                class="cbb-map-form__control disable"
                id="complementaryNumber"
                placeholder="Número"
                type="text"
                [value]="complementaryAddressData.number"
                readonly
              />
            </div>
          </div>
        </div>

        <button
          *ngIf="enabledSave"
          class="cbb-map-form__btn-continue mt-3"
          (click)="guardar()"
        >
          CONTINUAR
        </button>
    </div>
  </div>
</div>

<ng-template #contentUser let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Datos de Contacto</h4>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    ></button>
  </div>
  <form autocomplete="off" [formGroup]="formUser" (ngSubmit)="saveUser()">
    <div class="modal-body">
      <input
        type="text"
        placeholder="Nombre (Razón Social)*"
        [style.border]="'1.5px solid lightgray'"
        [style.font-size.px]="22"
        class="w-100 mt-3 pt-3 pb-1 px-3 form-control rounded-0"
        formControlName="name"
        [class.is-invalid]="formUser.get('name')?.touched && formUser.get('name')?.invalid"
        aria-describedby="nameValidation"
      />

      <input
        type="text"
        placeholder="Email *"
        [style.border]="'1.5px solid lightgray'"
        [style.font-size.px]="22"
        class="w-100 mt-3 pt-3 pb-1 px-3 form-control rounded-0"
        formControlName="email"
        [class.is-invalid]="
          formUser.get('email')?.touched && formUser.get('email')?.invalid
        "
        aria-describedby="emailValidation"
      />

      <input
        type="text"
        placeholder="RUT a Facturar *"
        [style.border]="'1.5px solid lightgray'"
        [style.font-size.px]="22"
        class="w-100 mt-3 pt-3 pb-1 px-3 form-control rounded-0"
        formControlName="rut"
        [class.is-invalid]="formUser.get('rut')?.touched && formUser.get('rut')?.invalid"
        (change)="checkRUT()"
        aria-describedby="rutValidation"
      />
      <div
        *ngIf="formUser.get('rut')?.touched && formUser.get('rut')?.invalid"
        id="rutValidation"
        class="invalid-feedback"
      >
        Por favor ingrese un RUT válido
      </div>
    </div>
    <div class="modal-footer">
      <button
        type="submit"
        class="btn btn-success text-uppercase"
        [disabled]="!ngUserValid"
      >
        Guardar
      </button>
    </div>
  </form>
</ng-template>
